import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { VerificationSelector } from '../../store/Verification'


export const useVerificationGuard = (redirectPath = '/test-strip/email') => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isVerified } = useSelector(VerificationSelector.getVerificationState)

  useEffect(() => {
    if (!isVerified) {
      navigate(redirectPath, { state: { from: { pathname: location.pathname } } })
    }
  }, [isVerified, navigate])

  return isVerified
}